import React, { useState, useEffect } from "react"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap"
import { FiClock, FiCalendar, FiSave, FiBox } from "react-icons/fi"
import axios from "axios"
import "./AgendaModal.css"
import speakers from "pages/speakers"
import { isMobile } from "react-device-detect"

const AgendaModal = ({ isOpen, toggle }) => {
  const obj = JSON.parse(localStorage.getItem("authUser"))
  const [sessions, setSessions] = useState({})
  const [activeTab, setActiveTab] = useState("")
  const [showSpeaker, setshowSpeaker] = useState(false)
  const [interestedSessions, setInterestedSessions] = useState(
    obj?.Intrested || []
  )

  const [speakerImg, setSpeakerImg] = useState(null)

  const adjustToIst = utcDate => {
    utcDate = new Date(utcDate)
    let adjustedData = new Date(utcDate.getTime() - (5 * 60 + 30) * 60 * 1000)
    return adjustedData
  }

  const fetchAndStoreData = async () => {
    const adminPanel = isMobile
      ? `${process.env.REACT_APP_ADMIN}`
      : `${process.env.REACT_APP_ADMIN_LAPTOP}`

    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"))
      const userResponse = await fetch(`${adminPanel}/getUser/${authUser._id}`)
      const userData = await userResponse.json()
      localStorage.setItem("authUser", JSON.stringify(userData))
    } catch (error) {
      console.error("Failed to fetch data:", error)
    }
  }

  useEffect(async () => {
    let isMounted = true // Add mounted flag

    if (isOpen) {
      await fetchAndStoreData()
      axios
        .get(`${process.env.REACT_APP_ADMIN}/sessions/platformsession`)
        .then(async response => {
          if (!response.data || !response.data.length) {
            console.log("Error fetching agenda")
            return
          }
          let lowerCaseTicket_Variant = obj.Ticket_Variant
            ? obj.Ticket_Variant.toLowerCase()
            : ""
          const formattedSesions = response.data.reduce((acc, session) => {
            session.passType = session.passType
              ? session.passType.toLowerCase()
              : ""
            acc[session.day] = acc[session.day] || []
            acc[session.day].push({
              _id: session._id,
              time: adjustToIst(session.time),
              end: adjustToIst(session.end),
              title: session.title,
              description: session.description,
              attendees: session.attendees,
              speaker: session.speaker,
              hall: session.hall,
              group: session.Group,
              showBookBtn: session.showBookBtn,
              showIntrestedBtn: session.showIntrestedBtn,
              booking: session.booking,
              vipBooking: session.vipBooking,
              speakersImg: session.speakersImg,
              // validPass: !!(session.passType =="All" || session.passType==lowerCaseTicket_Variant),
              validPass: true,
              // time:session.time,
            })
            return acc
          }, {})

          const sessionsData = {}
          let defaultKey
          Object.keys(formattedSesions).forEach((sessionKey, index) => {
            if (index === 0) {
              defaultKey = sessionKey
            }
            sessionsData[sessionKey] = {
              name: `${sessionKey}`,
              data: formattedSesions[sessionKey],
            }
          })

          // Only update state if component is still mounted
          if (isMounted) {
            setSessions(sessionsData)
            setActiveTab(defaultKey)
          }
        })
        .catch(error => {
          console.error("Error fetching sessions:", error)
        })
    }

    // cleanup function to set isMounted false on unmount
    return () => {
      isMounted = false
    }
  }, [isOpen, obj.Ticket_Variant])

  const bookSession = (Group, sessionId, validPass) => {
    const userId = obj?._id
    if (validPass) {
      axios
        .post(`${process.env.REACT_APP_ADMIN}/sessions/${sessionId}/book`, {
          userId,
          Group,
        })
        .then(response => {
          alert(
            "Your session is booked - please show your QR code at the entry of this session"
          )
          const el = document.getElementById(sessionId)
          if (el) {
            el.classList.add("disabled")
            el.innerText = "Registered"
          }
        })
        .catch(error => {
          console.log(error)
          alert(error?.response?.data?.error || "Booking failed")
        })
    } else {
      alert("Booking of this session is restricted")
    }
  }

  // const bookIntrest = (title, sessionId) => {
  //   const userId = obj?._id
  //   const validPass = true

  //   if (validPass) {
  //     axios
  //       .post(`${process.env.REACT_APP_ADMIN}/sessions/${sessionId}/intrest`, {
  //         userId,
  //         title,
  //       })
  //       .then(response => {
  //         const el = document.getElementById(`interested${sessionId}`)
  //         if (el) {
  //           el.classList.add("disabled")
  //           el.innerText = "♡"
  //         }
  //       })
  //       .catch(error => {
  //         console.log(error)
  //         alert(error?.response?.data?.error || "Interest shown failed")
  //       })
  //   } else {
  //     alert("Booking of this session is restricted")
  //   }
  // }

const bookIntrest = (title, sessionId) => {
  const userId = obj?._id;
  const isInterested = interestedSessions.includes(title);
  const url = `${process.env.REACT_APP_ADMIN}/sessions/${sessionId}/${isInterested ? "deintrest" : "intrest"}`;

  const axiosMethod = isInterested ? axios.patch : axios.post;

  axiosMethod(url, { userId, title })
    .then(() => {
      setInterestedSessions(prev =>
        isInterested
          ? prev.filter(item => item !== title)
          : [...prev, title]
      );
    })
    .catch(error => {
      console.error(error);
      alert(error?.response?.data?.error || "Action failed");
    });
};


  const addToCalendar = session => {
    const Time = "2025-08-29T02:30:00Z"
    const end = "2025-08-29T11:00:00Z"
    const title = "FujiFilm Annual Day 2026"
    const startTime = new Date(Time)
    const endTime = new Date(end)
    const formattedStartTime = startTime.toISOString().replace(/-|:|\.\d+/g, "")
    const formattedEndTime = endTime.toISOString().replace(/-|:|\.\d+/g, "")

    const icsMSG = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
URL:${document.URL}
DTSTART:${formattedStartTime}
DTEND:${formattedEndTime}
// SUMMARY:${session.title}
SUMMARY:${title}

// DESCRIPTION:${session.description}
LOCATION:Online
END:VEVENT
END:VCALENDAR`

    const blob = new Blob([icsMSG], { type: "text/calendar" })
    const link = document.createElement("a")
    link.href = window.URL.createObjectURL(blob)
    link.setAttribute("download", `Converge.ics`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleShowSpeaker = imgUrl => {
    setSpeakerImg(imgUrl)
    setshowSpeaker(true)
  }

  return (
    <>
      {showSpeaker && (
        <Modal
          isOpen={showSpeaker}
          toggle={() => setshowSpeaker(false)}
          centered
          style={{ width: "auto" }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">Speaker</h5>
            <button
              type="button"
              onClick={() => setshowSpeaker(false)}
              className="close"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body text-center">
            {speakerImg && (
              <img
                src={speakerImg}
                alt="Speaker"
                style={{ maxWidth: "100%", borderRadius: "8px" }}
              />
            )}
          </div>
        </Modal>
      )}
      <Modal isOpen={isOpen} toggle={toggle} className="agenda-modal">
        <ModalHeader toggle={toggle} className="">
          Agenda
        </ModalHeader>
        <ModalBody className="agenda-body">
          <Nav tabs className="nav-tabs-custom nav-justified">
            {/* {Object.keys(sessions).map(day => (
              <NavItem key={day}>
                <NavLink
                  active={activeTab === day}
                  onClick={() => {
                    setActiveTab(day)
                  }}
                >
                  {sessions[day]["name"]}
                </NavLink>
              </NavItem>
            ))} */}
          </Nav>
          <Nav vertical className="agenda-nav">
            <Button
              size="lg"
              color="Dark"
              className="agenda-button"
              onClick={() => addToCalendar(sessions)}
            >
              <FiCalendar className="agenda-button-icon" />
              Add to Calendar
            </Button>
            {sessions[activeTab]?.["data"]?.map((session, idx) => (
              <div
                key={session._id || idx}
                className="agenda-session"
                style={{ "--i": idx }}
              >
                <h4 className="agenda-day">{session.day}</h4>
                <NavItem className="agenda-item">
                  <NavLink className="agenda-link">
                    {/* <div className="agenda-time-title">
                    <span className="agenda-title">{session.title}</span>
                  </div> */}

                    <div className="agenda-time-title agenda-title">
                      {session.title.split("|").map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </div>

                    <div style={{ marginBottom: "2%" }}>
                      <FiClock className="agenda-icon" />
                      <strong className="agenda-time">
                        &nbsp;
                        {new Date(session.time).toLocaleTimeString(undefined, {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                        &nbsp;&nbsp;&nbsp;-
                      </strong>
                      <strong className="agenda-time">
                        &nbsp;
                        {new Date(session.end).toLocaleTimeString(undefined, {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </strong>
                    </div>

                    {/* <div className="agenda-description">
                    {session.description}
                  </div> */}

                    {/* {session.speaker && (
                    <div
                      className="agenda-description"
                      dangerouslySetInnerHTML={{
                        __html: `<strong>Speaker: </strong> ${session.speaker}`,
                      }}
                    />
                  )} */}
                    {/* {session.speaker && (
                    <div className="agenda-description">
                      <strong>Speaker: </strong>
                      {session.speaker.split("|").map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}
                    </div>
                  )} */}

                    {session.hall && (
                      <div
                        className="agenda-description"
                        dangerouslySetInnerHTML={{
                          __html: `<strong>Hall: </strong> ${session.hall}`,
                        }}
                      />
                    )}
                    <div className="agenda-buttons">
                      {/* <Button
                      size="sm"
                      color="Dark"
                      className="agenda-button"
                      onClick={() => addToCalendar(session)}
                    >
                      <FiCalendar className="agenda-button-icon" />
                      Add to Calendar
                    </Button> */}

                      {/* {session?.showIntrestedBtn && (
                        <Button
                          size="sm"
                          color="Dark"
                          className="agenda-button"
                          id={`interested${session._id}`}
                          onClick={() =>
                            bookIntrest(session.title, session._id)
                          }
                        >
                          {obj?.Intrested?.includes(session.title) ? (
                            "♡"
                          ) : (
                            <>
                              <FiBox className="agenda-button-icon" />{" "}
                              Interested
                            </>
                          )}
                        </Button>
                      )} */}

                      {session?.showIntrestedBtn && (
                        <Button
                          size="sm"
                          color="Dark"
                          className="agenda-button"
                          id={`interested${session._id}`}
                          onClick={() =>
                            bookIntrest(session.title, session._id)
                          }
                        >
                          {interestedSessions.includes(session.title) ? (
                            "♡"
                          ) : (
                            <>
                              <FiBox className="agenda-button-icon" />{" "}
                              Interested
                            </>
                          )}
                        </Button>
                      )}

                      {/* {session?.showIntrestedBtn && (
                        <Button
                          size="sm"
                          color="Dark"
                          className="agenda-button"
                          id={`interested${session._id}`}
                          onClick={() => toggleInterested(session._id)}
                        >
                          {interestedSessions.includes(session._id) ? (
                            "♡"
                          ) : (
                            <>
                              <FiBox className="agenda-button-icon" />{" "}
                              Interested
                            </>
                          )}
                        </Button>
                      )} */}

                      {session?.booking && session?.showBookBtn && (
                        <Button
                          size="sm"
                          color="Dark"
                          className="agenda-button"
                          id={session._id}
                          disabled={session?.attendees?.includes(obj._id)}
                          onClick={() =>
                            bookSession(
                              session.group,
                              session._id,
                              session.validPass
                            )
                          }
                        >
                          <FiSave className="agenda-button-icon" />
                          {session?.attendees?.includes(obj._id)
                            ? "Already Registered"
                            : "Book"}
                        </Button>
                      )}
                      {session?.speakersImg && (
                        <Button
                          size="sm"
                          color="dark"
                          className="agenda-button"
                          id={session._id}
                          onClick={() => handleShowSpeaker(session.speakersImg)}
                        >
                          Speaker
                        </Button>
                      )}
                    </div>
                  </NavLink>
                </NavItem>
              </div>
            ))}
          </Nav>
        </ModalBody>
      </Modal>
    </>
  )
}

export default AgendaModal
